import React from 'react'
import { Typography } from 'antd'
import { SoundTwoTone } from '@ant-design/icons'

const NotificationBanner = ({ icon, heading, description }) => (
  <div className="t-bg-[#F1F1F2] t-p-5 t-rounded-2xl t-flex t-items-start t-gap-4 t-mb-3">
    <div className="t-mt-1">
      {icon ?? (
        <SoundTwoTone style={{ fontSize: '2rem' }} twoToneColor="#1BA1E2" />
      )}
    </div>
    <div>
      <Typography className="t-text-roboto t-text-[22px] t-leading-[30.01px] t-font-semibold t-text-[rgba(0,0,0,1)]">
        {heading}
      </Typography>
      <Typography className="t-text-roboto t-text-[18px] t-leading-[24.55px] t-font-normal t-text-[rgba(0,0,0,0.6)]">
        {description}
      </Typography>
    </div>
  </div>
)

export default NotificationBanner
